import { render, staticRenderFns } from "./AddNewSectionLauncher.vue?vue&type=template&id=55e4f234&scoped=true"
import script from "./AddNewSectionLauncher.vue?vue&type=script&lang=js"
export * from "./AddNewSectionLauncher.vue?vue&type=script&lang=js"
import style0 from "./AddNewSectionLauncher.vue?vue&type=style&index=0&id=55e4f234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e4f234",
  null
  
)

export default component.exports